import { cn } from "@/lib/tailwind";
import React from "react";

const SummaryView = ({
  name,
  price,
  title,
  className,
}: {
  className?: string;
  name: React.ReactNode;
  title: React.ReactNode;
  price?: React.ReactNode;
}) => {
  return (
    <div className={cn("flex justify-between text-sm", className)}>
      <div>
        <p className="font-semibold">{title}</p>
        <p className="text-tertiary-6">{name}</p>
      </div>
      {price && <p className="font-bold">{price}</p>}
    </div>
  );
};

export default SummaryView;
